<template>
  <div
    class="expander"
    :class="{
      '-open': open,
      '-triangle': icon === 'expander',
      '-minimal': minimal,
    }"
  >
    <div
      class="expander-link mb-0"
      v-if="collapseText.length === 0 || (collapseText.length > 0 && !open)"
      tabindex="0"
      @click="toggle"
      @keypress.enter="toggle"
      :id="'tab-' + label"
    >
      <slot></slot>
      <span v-if="!minimal" class="expander-icon pl-2">
        <Chevron
          v-if="icon === 'chevron-down'"
          :direction="'down'"
          :color="inverted ? Globals.colors.white : Globals.colors.primary"
          :size="small ? 14 : 16"
        />
      </span>
    </div>
    <div
      :id="label"
      class="mt-2"
      :class="open ? '' : '-hidden'"
      v-html="content"
    ></div>

    <div
      class="expander-link"
      v-if="collapseText.length > 0 && open"
      tabindex="0"
      @click="toggle"
      @keypress.enter="toggle"
      :id="'tab-' + label"
    >
      {{ collapseText }}
      <span v-if="!minimal" class="expander-icon pl-2">
        <Chevron
          v-if="icon === 'chevron-down'"
          :direction="'up'"
          :color="inverted ? Globals.colors.white : Globals.colors.primary"
          :size="small ? 14 : 16"
        />
      </span>
    </div>
  </div>
</template>

<script>

/**
 * Expander component with arrow
 *
 * @displayName Expander
 * @version 1.0.0
 */

import Chevron from '@/Scripts/components/shared/svg/Chevron/Chevron.vue';

export default {
  name: 'Expander',
  components: {
    Chevron
  },
  props: {
    /**
     * Content to expand
     */
    content: {
      type: String,
      default: ' ',
      required: true
    },

    /**
     * Label, if mulitple expands on same page
     */
    label: {
      type: String,
      default: ''
    },

    /**
     * Expand by default
     */
    expanded: {
      type: Boolean,
      default: false
    },
    /**
     * Expander icon. chevron-down (default) | expander (small folder icons) | blank (none)
     */
    icon: {
      type: String,
      default: 'chevron-down',
      required: false
    },
    /**
     * White text and icon
     */
    inverted: {
      type: Boolean,
      default: false
    },
    /**
     * Small text and icon
     */
    small: {
      type: Boolean,
      default: false
    },
    collapseText: {
      type: String,
      default: ''
    },
    minimal: Boolean

  },
  data () {
    return {
      open: this.expanded
    };
  },
  methods: {
    toggle () {
      this.open = !this.open;
      this.$emit('onToggle', this.open);
    }
  },
  mounted () {
    if (this.expanded) {
      this.open = true;
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/defaults.scss";

.expander {
  cursor: pointer;

  .-hidden {
    display: none;
  }

  p:last-child {
    margin-bottom: 18px !important;
  }
  &-link {
    cursor: pointer;
    @include font-responsive(body);
  }

  &.-small {
    .expander-link {
      @include font-responsive(small);
    }

    .expander-icon > * {
      transform: scale(0.75);
    }
  }
  &.-minimal {
    .expander-link {
      color: $blue;
      @include font-responsive(small);
    }
    p:last-child {
      margin-bottom: 9px !important;
    }
  }

  svg.-inverted {
    fill: $white;
    stroke: transparent;

    path:nth-child(2) {
      fill: $white;
    }
  }

  &.-triangle {
    > div {
      margin-left: 18px;
    }
    .expander-link {
      position: relative;
      margin-left: 18px;

      &::before {
        position: absolute;
        width: 0;
        height: 0;
        margin-top: 5px;
        margin-left: -18px;
        border-style: solid;
        // border-style: inset;
        border-width: 6px 0 6px 10px;
        border-color: transparent transparent transparent #000000;
        content: "";
        //transition: transform .1s;

        @include media-breakpoint-down(sm) {
          transform: scale(0.75) translateY(-3px);
        }
      }
    }

    &.-open .expander-link::before {
      transform: rotate(90deg);
      @include media-breakpoint-down(sm) {
        transform: scale(0.75) translateY(-3px) rotate(90deg);
      }
    }
  }
}
</style>
